import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "px-6 py-4 text-left modal-content" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "block mb-6" }
const _hoisted_8 = { id: "sample" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "block"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "block"
}
const _hoisted_14 = ["poster"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 4,
  class: "block"
}
const _hoisted_17 = {
  key: 5,
  class: "flex flex-wrap w-full gap-2 mb-2"
}
const _hoisted_18 = {
  key: 0,
  controls: "",
  class: "w-full h-48 object-cover rounded-md mb-2 border"
}
const _hoisted_19 = ["src", "type"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "block" }
const _hoisted_23 = { class: "block" }
const _hoisted_24 = { class: "block" }
const _hoisted_25 = { class: "block" }
const _hoisted_26 = { class: "block" }
const _hoisted_27 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-2"
}
const _hoisted_28 = {
  key: 0,
  class: "px-2 py-1 bg-gray-200 rounded-md text-sm flex items-center"
}
const _hoisted_29 = { class: "ml-1 text-red-500" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onKeydown"]
const _hoisted_32 = { class: "flex justify-end items-center pt-2 relative" }

import { ref, watch, onMounted, computed } from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import Editor from "@tinymce/tinymce-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NewTgModal',
  props: {
  categories: {
    type: Array,
    required: true,
  },
  types: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const tg = ref({
  title: "",
  subtitle: "",
  slug: "",
  category_id: "",
  body: "",
  type_id: "",
  thumbnail_image: "",
  banner_video: "",
  seo_title: "",
  seo_description: "",
  canonical_tag: "",
  status_id: 1,
  created_by: "",
  approved_by: "",
  published_at: "",
  views: 0,
  notes: "",
  tags: "",
  carousel: [],
});
const newTag = ref("");

const thumbnailImage = ref(null);
const bannerVideo = ref(null);
const isSubmitting = ref(false);
const carousel_image_previews = ref([]);
const content = ref("");
const isContentCopyPasted = ref(false);

const handleSubmit = async () => {
  tg.value.body = content.value;

  if (!tg.value.title || !tg.value.slug || !tg.value.subtitle || !tg.value.category_id || !tg.value.body || !tg.value.type_id || !tg.value.status_id) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please fill all mandatory fields!",
    });
    return;
  }

  if (tg.value.tags === "") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please add at least one tag!",
    });
    return;
  }

  try {
    isSubmitting.value = true;
    const formData = new FormData();

    if (isContentCopyPasted.value) {
      tg.value.notes += " dca3f55f1e0d786ce9992df88ccfc16a";
      isContentCopyPasted.value = false;
    }

    for (const key in tg.value) {
      if (key === "carousel") {
        if (tg.value.carousel && tg.value.carousel.length > 0) {
          tg.value.carousel.forEach((file, index) => {
            formData.append(`carousel[${index}]`, file.file);
          });
        }
      } else {
        formData.append(key, tg.value[key]);
      }
    }

    formData.forEach((value, key) => {
      console.log(key + ": " + value);
    });

    const token = localStorage.getItem("token");
    const response = await axios.post(`${baseUrl}/tour-guide/store`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    isSubmitting.value = false;
    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Tour guide created successfully!",
    });
  } catch (error) {
    console.error(error);
    isSubmitting.value = false;
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "There are some issues with the content. Please try again!",
    });
  }
};

const clearForm = () => {
  tg.value = {
    title: "",
    slug: "",
    subtitle: "",
    category_id: "",
    body: "",
    type_id: "",
    thumbnail_image: "",
    banner_video: "",
    seo_title: "",
    seo_description: "",
    canonical_tag: "",
    status_id: "",
    created_by: "",
    approved_by: "",
    published_at: "",
    views: "",
    notes: "",
    tags: "",
    carousel: [],
  };
};

const addTag = () => {
  if (newTag.value.trim() === "") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Tag cannot be empty!",
    });
    return;
  }

  const tagsArray = tg.value.tags ? tg.value.tags.split(",") : [];
  tagsArray.push(newTag.value.trim());
  tg.value.tags = tagsArray.join(", ");

  newTag.value = "";
};

const removeTag = (index) => {
  let tagsArray = tg.value.tags.split(",");
  tagsArray.splice(index, 1);
  tg.value.tags = tagsArray.join(", ");
};

const handleThumbanilImageUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    tg.value.thumbnail_image = file;

    thumbnailImage.value = URL.createObjectURL(file);
  }
};

const handleBannerVideoUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    tg.value.banner_video = file;

    bannerVideo.value = URL.createObjectURL(file);
  }
};

const handleCarouselImageUpload = (event) => {
  const newFiles = event.target.files;

  if (newFiles.length > 0) {
    Array.from(newFiles).forEach((file) => {
      tg.value.carousel.push({
        file: file,
        previewUrl: URL.createObjectURL(file),
      });
    });
  }

  event.target.value = null;
};

const onPaste = () => {
  isContentCopyPasted.value = true;
};

const tinyMceImageUploader = (blobInfo, progress) =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", blobInfo.blob(), blobInfo.filename());

    const uploadUrl = `${baseUrl}/content/upload`;

    fetch(uploadUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        progress(100);

        if (!response.ok) {
          return response
            .json()
            .then((err) => {
              throw new Error(err.message || `HTTP error! status: ${response.status}`);
            })
            .catch(() => {
              throw new Error(`HTTP error! status: ${response.status}`);
            });
        }
        return response.json();
      })
      .then((data) => {
        if (data.success && data.data && data.data.file_path) {
          resolve(data.data.file_path);
        } else {
          const errorMessage = data.message || "Server did not return a valid image URL or success status.";
          console.error("Image upload failed:", errorMessage, data);
          reject(errorMessage);
        }
      })
      .catch((error) => {
        console.error("Image upload failed:", error);
        reject(`Image upload failed: ${error.message || error}`);
      });
  });

const isVideo = (item) => {
  if (item && item.file && item.file.type) {
    return item.file.type.startsWith("video/");
  }

  if (typeof item === "string" && item.match(/\.(mp4|webm|ogg)$/)) {
    return true;
  }

  if (typeof item === "string" && item.startsWith("http")) {
    const url = new URL(item);
    return url.pathname.endsWith(".mp4") || url.pathname.endsWith(".webm") || url.pathname.endsWith(".ogg");
  }
  return false;
};

const removeCarouselItem = (index) => {
  const itemToRemove = tg.value.carousel[index];
  if (itemToRemove && itemToRemove.previewUrl) {
    URL.revokeObjectURL(itemToRemove.previewUrl);
  }
  tg.value.carousel.splice(index, 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex items-center justify-between pb-3" }, [
      _createElementVNode("p", { class: "text-2xl font-bold" }, "Create new travel guide")
    ], -1)),
    _createElementVNode("label", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("title"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tg.value.title) = $event))
      }, null, 512), [
        [_vModelText, tg.value.title]
      ])
    ]),
    _createElementVNode("label", _hoisted_3, [
      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("Slug"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tg.value.slug) = $event))
      }, null, 512), [
        [_vModelText, tg.value.slug]
      ])
    ]),
    _createElementVNode("label", _hoisted_4, [
      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("subtitle"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tg.value.subtitle) = $event))
      }, null, 512), [
        [_vModelText, tg.value.subtitle]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("category"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("select", {
        class: "block w-full h-full px-4 py-2 pr-8 mb-6 leading-tight text-gray-700 bg-white border border-gray-400 rounded-l appearance-none focus:outline-none focus:bg-white focus:border-gray-500 text-sm",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tg.value.category_id) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category) => {
          return (_openBlock(), _createElementBlock("option", {
            key: category.id,
            value: category.id,
            class: "whitespace-nowrap"
          }, _toDisplayString(category.name), 9, _hoisted_6))
        }), 128))
      ], 512), [
        [_vModelSelect, tg.value.category_id]
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none mt-6" }, [
        _createElementVNode("svg", {
          class: "w-4 h-4 fill-current",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20"
        }, [
          _createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
        ])
      ], -1))
    ]),
    _createElementVNode("label", _hoisted_7, [
      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("Body"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Editor), {
          modelValue: content.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((content).value = $event)),
          licenseKey: "gpl",
          "tinymce-script-src": "/tinymce/tinymce.min.js",
          init: {
            height: 500,
            menubar: false,
            toolbar_mode: 'sliding',
            plugins: ['anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount'],
            toolbar:
              'undo redo | blocks | bold italic underline strikethrough | link image media table mergetags | spellcheckdialog a11ycheck typography | align | checklist numlist bullist',
            images_upload_handler: tinyMceImageUploader,
            block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;',
            media_alt_source: false,
            media_poster: false,
            forced_root_block: 'p',
            setup(editor) {
              editor.on('paste', (e) => {
                // e.preventDefault(); // Block paste
                onPaste();
              });
              // editor.on('drop', (e) => {
              //   e.preventDefault(); // Block drag-drop paste
              //   onPaste();
              // });
              editor.on('init', () => {
                // Add a custom class to the editor wrapper
                const iframeContainer = editor.getContainer();
                iframeContainer.style.border = '1px solid #9ca3af'; // Example: Indigo-600 border
                iframeContainer.style.borderRadius = '8px';
              });
            },
          },
          class: "mt-1 mb-6 border border-gray-900 rounded-md",
          contentType: "html"
        }, null, 8, ["modelValue", "init"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("type"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("select", {
        class: "block w-full h-full px-4 py-2 pr-8 mb-6 leading-tight text-gray-700 bg-white border border-gray-400 rounded-l appearance-none focus:outline-none focus:bg-white focus:border-gray-500 text-sm",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tg.value.type_id) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.types, (type) => {
          return (_openBlock(), _createElementBlock("option", {
            key: type.id,
            value: type.id,
            class: "whitespace-nowrap"
          }, _toDisplayString(type.name), 9, _hoisted_10))
        }), 128))
      ], 512), [
        [_vModelSelect, tg.value.type_id]
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none mt-6" }, [
        _createElementVNode("svg", {
          class: "w-4 h-4 fill-current",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20"
        }, [
          _createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
        ])
      ], -1))
    ]),
    (tg.value.type_id === 1 || tg.value.type_id === 2)
      ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
            _createTextVNode("thumbnail image"),
            _createElementVNode("span", { class: "text-red-500" }, "*")
          ], -1)),
          _createElementVNode("input", {
            type: "file",
            class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
            onChange: handleThumbanilImageUpload
          }, null, 32)
        ]))
      : _createCommentVNode("", true),
    ((tg.value.type_id === 1 || tg.value.type_id === 2) && tg.value.thumbnail_image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: thumbnailImage.value,
          alt: "Thumbnail Preview",
          class: "mt-2 mx-auto w-1/3 h-48 object-cover rounded-md"
        }, null, 8, _hoisted_12))
      : _createCommentVNode("", true),
    (tg.value.type_id === 2)
      ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
            _createTextVNode("banner video"),
            _createElementVNode("span", { class: "text-red-500" }, "*")
          ], -1)),
          _createElementVNode("input", {
            type: "file",
            class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
            onChange: handleBannerVideoUpload
          }, null, 32)
        ]))
      : _createCommentVNode("", true),
    (tg.value.banner_video && tg.value.type_id === 2)
      ? (_openBlock(), _createElementBlock("video", {
          key: 3,
          controls: "",
          class: "mb-4 mx-auto w-1/3 h-56 object-cover",
          poster: thumbnailImage.value
        }, [
          _createElementVNode("source", {
            src: bannerVideo.value,
            type: "video/mp4"
          }, null, 8, _hoisted_15)
        ], 8, _hoisted_14))
      : _createCommentVNode("", true),
    (tg.value.type_id === 3)
      ? (_openBlock(), _createElementBlock("label", _hoisted_16, [
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
            _createTextVNode("carousel images"),
            _createElementVNode("span", { class: "text-red-500" }, "*")
          ], -1)),
          _createElementVNode("input", {
            type: "file",
            multiple: "",
            class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
            onChange: handleCarouselImageUpload
          }, null, 32)
        ]))
      : _createCommentVNode("", true),
    (tg.value.type_id === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tg.value.carousel, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.previewUrl,
              class: "relative"
            }, [
              (isVideo(item))
                ? (_openBlock(), _createElementBlock("video", _hoisted_18, [
                    _createElementVNode("source", {
                      src: item?.previewUrl ? item?.previewUrl : item,
                      type: item.file.type
                    }, null, 8, _hoisted_19)
                  ]))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: item?.previewUrl ? item?.previewUrl : item,
                    alt: "Carousel Preview",
                    class: "w-full h-48 object-cover rounded-md mb-2 border"
                  }, null, 8, _hoisted_20)),
              _createElementVNode("button", {
                onClick: ($event: any) => (removeCarouselItem(index)),
                class: "absolute top-1 right-1 px-2 bg-red-500 text-white rounded-full"
              }, "x", 8, _hoisted_21)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_22, [
      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("seo title"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tg.value.seo_title) = $event))
      }, null, 512), [
        [_vModelText, tg.value.seo_title]
      ])
    ]),
    _createElementVNode("label", _hoisted_23, [
      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("seo description"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((tg.value.seo_description) = $event))
      }, null, 512), [
        [_vModelText, tg.value.seo_description]
      ])
    ]),
    _createElementVNode("label", _hoisted_24, [
      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("canonical tag"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tg.value.canonical_tag) = $event))
      }, null, 512), [
        [_vModelText, tg.value.canonical_tag]
      ])
    ]),
    _createElementVNode("label", _hoisted_25, [
      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, "notes", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((tg.value.notes) = $event))
      }, null, 512), [
        [_vModelText, tg.value.notes]
      ])
    ]),
    _createElementVNode("label", _hoisted_26, [
      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-sm text-gray-700 capitalize" }, [
        _createTextVNode("tags"),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      (tg.value.tags != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((tg.value.tags || '').split(',').filter((t) => t.trim()), (tag, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                (tag != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createTextVNode(_toDisplayString(tag) + " ", 1),
                      _createElementVNode("button", _hoisted_29, [
                        (_openBlock(), _createElementBlock("svg", {
                          onClick: ($event: any) => (removeTag(index)),
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          "stroke-width": "1.5",
                          stroke: "currentColor",
                          class: "size-6",
                          width: "15",
                          height: "15"
                        }, _cache[26] || (_cache[26] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          }, null, -1)
                        ]), 8, _hoisted_30))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newTag).value = $event)),
        class: "block w-full mt-1 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm",
        onKeydown: _withKeys(_withModifiers(addTag, ["prevent"]), ["enter"])
      }, null, 40, _hoisted_31), [
        [_vModelText, newTag.value]
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-6" }, "Press Enter to add the tag", -1))
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("button", {
        onClick: clearForm,
        class: "p-3 px-6 py-3 mr-2 text-indigo-500 bg-transparent rounded-lg hover:bg-gray-100 hover:text-indigo-400 focus:outline-none"
      }, "Clear"),
      _createElementVNode("button", {
        onClick: handleSubmit,
        type: "submit",
        class: "px-6 py-3 font-medium tracking-wide text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none"
      }, _toDisplayString(isSubmitting.value ? "Submitting" : "Submit to review"), 1)
    ])
  ]))
}
}

})